import React from 'react';
import Marquee from 'react-double-marquee';
import { Link } from 'react-scroll';
import creative from '../../img/main/creative.png';
import title from '../../img/main/title.svg';
import title_mob from '../../img/main/title_mob.svg';
import CopyBtn from './copyBtn/copyBtn';
import './main.css';

export default class Main extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			firstScreenHeight: document.documentElement.clientHeight,
		};

		this.changeScreenHeight = this.changeScreenHeight.bind(this);
	}

	changeScreenHeight() {
		this.setState({
			firstScreenHeight: document.documentElement.clientHeight,
		});

		document.querySelector('.main_wrap').style.height =
			this.state.firstScreenHeight + 'px';
	}

	componentWillMount = () => {
		window.addEventListener('resize', this.changeScreenHeight);
		return () => window.removeEventListener('resize', this.changeScreenHeight);
	};

	componentDidMount() {
		this.changeScreenHeight();
	}

	render() {
		return (
			<div className='main_wrap'>
				<div className='main_bg'></div>
				<div className='main_grad'></div>
				<div className='container main_block'>
					<div className='main_content main_item'>
						<p className='main_date p2 grey'>December 3-5, ONLINE</p>
						<h1 className='main_title'>
							Worldwide<br/> <span className='accent'>SOFTWARE Architecture</span><br/> Summit WINTER'24
						</h1>
						{/* <p className='newFormat'>New Format Micro Workshops</p> */}
						<div className='main_title_img_block'>
							<img
								className='main_title_img main_title_img--pc'
								src={title}
								alt=''
							/>
							<img
								className='main_title_img main_title_img--mob'
								src={title_mob}
								alt=''
							/>
						</div>
						<p class="main_dates p2 grey">
							December 3rd <span className='br'>–</span> <span className='accent'>Architecture</span> Junior Day<br/>
							December 4th <span className='br'>–</span> <span className='accent'>Architecture</span> Senior Day<br/>
							December 5th <span className='br'>–</span> <span className='accent'>DevOps</span> Day – 3 Junior and 6 Senior Topics</p>
						<p class='main_desc p2 accent'>Latest insights and trends 2024 presented in 25+ real-life use cases</p>
						<div className='main_btns_wrap'>
							<Link
								activeClass='active'
								to='tickets'
								spy={true}
								smooth={true}
								offset={80}
								className='main_btn button'
							>
								GET TICKETs
							</Link>
							<CopyBtn />
						</div>
					</div>
					<div className='main_img_block'>
						<img className='main_creative' src={creative} alt='' />
					</div>
				</div>
				<div className='main_anim'>
					<Marquee direction='left' speed={0.03} delay={0} childMargin={0}>
						<span className='purple'>
							{' '}
							• Learn Trending Innovations Explained by Trusted Experts
						</span>
						<span>
							{' '}
							• Learn Trending Innovations Explained by Trusted Experts
						</span>
						<span className='purple'>
							{' '}
							• Learn Trending Innovations Explained by Trusted Experts
						</span>
						<span>
							{' '}
							• Learn Trending Innovations Explained by Trusted Experts
						</span>
						<span className='purple'>
							{' '}
							• Learn Trending Innovations Explained by Trusted Experts
						</span>
						<span className='purple'>
							{' '}
							• Learn Trending Innovations Explained by Trusted Experts
						</span>
						<span>
							{' '}
							• Learn Trending Innovations Explained by Trusted Experts
						</span>
						<span className='purple'>
							{' '}
							• Learn Trending Innovations Explained by Trusted Experts
						</span>
						<span>
							{' '}
							• Learn Trending Innovations Explained by Trusted Experts
						</span>
					</Marquee>
				</div>
			</div>
		);
	}
}
